import * as React from 'react';

const SvgTeamFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M10.79 3H2v18h20V5h-9.53l-1.68-2Zm-.54 6.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5Zm5.5 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5Zm2.16 4.5.73 2h-3.72l-.73-2h3.72Zm-4.59 2H7.36l.73-2h4.5l.73 2Z" })
);

export { SvgTeamFill as default };
//# sourceMappingURL=TeamFill.es.js.map
